import { z } from 'zod'

export const SearchSchema = z.object({
  nameCN: z.union([z.string(), z.number()]).optional(),
  status: z.number().optional(),
  isHot: z.number().optional(),
  showOnHomepage: z.number().optional(),
  page: z.number().default(1),
  size: z.number().default(10),
})

export type Search = z.infer<typeof SearchSchema>
